import { AddressTypes, IAddress, IAddressFormatter, ISelectedAddress } from './address'
import { CountryCode } from '@carsys/enums/country-code'
import { formatAddressStreetThenHouseNumber } from './formatAddressStreetThenHouseNumber'
import { formatAddressPostalCodeThenCity } from './formatAddressPostalCodeThenCity'
import { formatAddressHouseNumberThenStreet } from './formatAddressHouseNumberThenStreet'
import { formatAddressCityThenPostalCode } from './formatAddressCityThenPostalCode'
import { formatAdressFull } from './formatAddressFull'
import pick from 'lodash/fp/pick'

export const addressFormatters: Record<string, IAddressFormatter> = {
  [CountryCode.BE]: {
    formatAddressStreet: (address: Partial<IAddress>, addressType: AddressTypes = 'Visitor') => {
      const addressKeys = Object.keys(address).filter(key => key.startsWith(addressType))
      const selectedAddress: ISelectedAddress = pick(addressKeys, address)
      return formatAddressStreetThenHouseNumber(selectedAddress, addressType)
    },
    formatAddressCity: (address: Partial<IAddress>, addressType: AddressTypes = 'Visitor') => {
      const addressKeys = Object.keys(address).filter(key => key.startsWith(addressType))
      const selectedAddress: ISelectedAddress = pick(addressKeys, address)
      return formatAddressPostalCodeThenCity(selectedAddress, addressType)
    },
    formatAddressFull: (address: Partial<IAddress>, addressType: AddressTypes = 'Visitor') => {
      const addressKeys = Object.keys(address).filter(key => key.startsWith(addressType))
      const selectedAddress: ISelectedAddress = pick(addressKeys, address)
      return formatAdressFull(selectedAddress, addressType, CountryCode.NL)
    }
  },
  [CountryCode.GB]: {
    formatAddressStreet: (address: Partial<IAddress>, addressType: AddressTypes = 'Visitor') => {
      const addressKeys = Object.keys(address).filter(key => key.startsWith(addressType))
      const selectedAddress: ISelectedAddress = pick(addressKeys, address)
      return formatAddressHouseNumberThenStreet(selectedAddress, addressType)
    },
    formatAddressCity: (address: Partial<IAddress>, addressType: AddressTypes = 'Visitor') => {
      const addressKeys = Object.keys(address).filter(key => key.startsWith(addressType))
      const selectedAddress: ISelectedAddress = pick(addressKeys, address)
      return formatAddressCityThenPostalCode(selectedAddress, addressType)
    },
    formatAddressFull: (address: Partial<IAddress>, addressType: AddressTypes = 'Visitor') => {
      const addressKeys = Object.keys(address).filter(key => key.startsWith(addressType))
      const selectedAddress: ISelectedAddress = pick(addressKeys, address)
      return formatAdressFull(selectedAddress, addressType, CountryCode.NL)
    }
  },
  [CountryCode.NL]: {
    formatAddressStreet: (address: Partial<IAddress>, addressType: AddressTypes = 'Visitor') => {
      const addressKeys = Object.keys(address).filter(key => key.startsWith(addressType))
      const selectedAddress: ISelectedAddress = pick(addressKeys, address)
      return formatAddressStreetThenHouseNumber(selectedAddress, addressType)
    },
    formatAddressCity: (address: Partial<IAddress>, addressType: AddressTypes = 'Visitor') => {
      const addressKeys = Object.keys(address).filter(key => key.startsWith(addressType))
      const selectedAddress: ISelectedAddress = pick(addressKeys, address)
      return formatAddressPostalCodeThenCity(selectedAddress, addressType)
    },
    formatAddressFull: (address: Partial<IAddress>, addressType: AddressTypes = 'Visitor') => {
      const addressKeys = Object.keys(address).filter(key => key.startsWith(addressType))
      const selectedAddress: ISelectedAddress = pick(addressKeys, address)
      return formatAdressFull(selectedAddress, addressType, CountryCode.NL)
    }
  },
  [CountryCode.DE]: {
    formatAddressStreet: (address: Partial<IAddress>, addressType: AddressTypes = 'Visitor') => {
      const addressKeys = Object.keys(address).filter(key => key.startsWith(addressType))
      const selectedAddress: ISelectedAddress = pick(addressKeys, address)
      return formatAddressStreetThenHouseNumber(selectedAddress, addressType)
    },
    formatAddressCity: (address: Partial<IAddress>, addressType: AddressTypes = 'Visitor') => {
      const addressKeys = Object.keys(address).filter(key => key.startsWith(addressType))
      const selectedAddress: ISelectedAddress = pick(addressKeys, address)
      return formatAddressPostalCodeThenCity(selectedAddress, addressType)
    },
    formatAddressFull: (address: Partial<IAddress>, addressType: AddressTypes = 'Visitor') => {
      const addressKeys = Object.keys(address).filter(key => key.startsWith(addressType))
      const selectedAddress: ISelectedAddress = pick(addressKeys, address)
      return formatAdressFull(selectedAddress, addressType, CountryCode.NL)
    }
  }
}
